/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "在 App Store 上下載",
      "與附近的社群見面",
      "與你在 Hive 中的朋友建立連結",
      "尋找志同道合的朋友",
      "不論你的興趣是什麼，都能找到相應的 Hive！",
      "安心做自己",
      "選擇私人或公開 Hive",
      "新手上路",
      "不論你的興趣是什麼，都能找到相應的 Hive",
      "在 Bumble BFF 的 Hive 中認識一群新朋友",
      "你收到邀請加入 Hive",
      "在 Bumble BFF 上透過新功能 Hive 認識當地社團。現在就前往 Bumble 建立你的 BFF 檔案。",
      "前往 Google  Play 下載",
      "管理 Cookie",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小時"
            ],
            "singular": [
                  "小時"
            ]
      },
      "minute": {
            "plural": [
                  "分鐘"
            ],
            "singular": [
                  "分鐘"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
